import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {SymptomsActions} from '../store';
import {SymptomsSelectors} from '../store/selectors';

@Injectable()
export class SymptomsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadSymptomsDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadSymptomsDone(): Observable<boolean> {
    return this.store.pipe(
      select(SymptomsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(SymptomsActions.ReadSymptoms());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
